export default __webpack_public_path__ + "static/media/100.9ab65aba.woff2";